export const DATADOG_ENABLED_ENVS = ['production']
export const SERVICE_NAME = 'gousto-webclient'

// e2e
export const E2E_SERVICE_NAME = 'gousto-webclient-e2e-staging---test'
export const E2E_DD_CTX_COOKIE = 'e2e_dd_ctx'
export const E2E_DD_APP_ID = '7eaa558f-a187-40c5-b743-9fd52d7aff3a'
export const E2E_DD_CLIENT_TOKEN = 'pub7210de2a9d84977c7611bb974aa9f74f'
